/* import __COLOCATED_TEMPLATE__ from './lsg-checkbox-ternary.hbs'; */
import Component from '@ember/component';
import { action } from '@ember/object';

/**
 * Enum for the checkbox's states
 *
 * @type {Object}
 */
export const LSG_CHECKBOX_TERNARY__STATES = {
  OFF: 'off',
  INDETERMINATE: 'indeterminate',
  ON: 'on'
};

/**
 * This checkbox will be able to support three states
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: '',

  /**
   * Register services
   */

  /*********************************
   * REQUIRED PARAMS
   *********************************/
  checkboxState: LSG_CHECKBOX_TERNARY__STATES.OFF,

  /**
   * This callback is called when the ternary checkbox state changes.
   *
   * @param {String} newState     of type LSG_CHECKBOX_TERNARY__STATES.*
   */
  onStateChanged: (newState) => { },

  /**
   * @param {MouseEvent} e
   */
  onClick: action(function(e) {
    e.preventDefault();

    switch (this.get('checkboxState')) {
      case LSG_CHECKBOX_TERNARY__STATES.INDETERMINATE:
        this.get('onStateChanged')(LSG_CHECKBOX_TERNARY__STATES.ON);
        break;
      case LSG_CHECKBOX_TERNARY__STATES.ON:
        this.get('onStateChanged')(LSG_CHECKBOX_TERNARY__STATES.OFF);
        break;
      default:
        this.get('onStateChanged')(LSG_CHECKBOX_TERNARY__STATES.INDETERMINATE);
        break;
    }
  }),
});
